/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Divider,
    Grid,
    Paper,
    Stack,
    Typography,
    Chip
} from '@mui/material';
import { Formik } from 'formik';
import {
    get,
    identity,
    isEmpty,
    map,
    pickBy,
    find
} from "lodash"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import { Alert, Notification, AutoComplete, InputText, Skeleton } from '../../../components/form';
import { useCanView } from "../../../config/hook/UserPermissions";
import LogsModal from "./LogsModal";
import HistoryIcon from '@mui/icons-material/History';
import { getLog } from "../../../store/config/thunk/log/getAll";
import validator from "./validator";

import { getInvoiceId } from "../../../store/transactions/thunk/invoice/getId";
import { postInvoice } from "../../../store/transactions/thunk/invoice/post";
import { putInvoice } from "../../../store/transactions/thunk/invoice/put";
import { getClient } from "../../../store/masters/thunk/client/getAll";

const NewEdit = ({ setBtns, isEdit }) => {
    const formikRef = useRef();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("invoice");
const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
    const [isMount, setIsMount] = useState(false);
    const canView = useCanView();
    const [openModalLog, setOpenModalLog] = useState(false);

    const current = useSelector(state => state.transactions.invoice.detail);

    const post = useSelector(state => state.transactions.invoice.post);
    const put = useSelector(state => state.transactions.invoice.put);
    const client = useSelector(state => state.masters.client);

    const invoiceClient = get(current, "data.customerId")
        ? [{ value: get(current, "data.customerId"), label: `${get(current, "data.customerId")} - ${get(current, "data.customerName")}` }]
        : [];

    const clientsList = map(
        get(client, "data.data", []).filter(c =>
            get(c, "isActive") === "ACTIVO" &&
            get(c, "customerId") !== get(current, "data.customerId")
        ),
        ({ customerId, name }) => ({
            value: customerId,
            label: `${customerId} - ${name}`,
        })
    );

    const clients = [...invoiceClient, ...clientsList];

    const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });

    const getData = () => {
        let Screen = "FACTURACION CLIENTE"
        dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
        dispatch(getInvoiceId({ id }));
        dispatch(getClient({ Export: true }));
    }

    useEffect(() => {
        getData();
    }, []);

    const reload = () => {getData();}

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
        if (get(post, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post, put]);

    const onSubmit = (values) => {
        if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE", "update")) {
            const idInvoice = Number(id);
            const body = {
                customerId: get(values, "idClient"),
                comments: get(values, "comments")
            }
    
            const whitOutNulls = pickBy(body, identity);
            if (idInvoice) { dispatch(putInvoice(whitOutNulls, idInvoice)) }
            else { dispatch(postInvoice(whitOutNulls)) }
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar la factura del cliente.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }


    const initialValues = {
        idClient: id ? get(current, "data.customerId", "") : "",
        comments: id ? get(current, "data.comments", "") : ""
    }
    // console.log(get(current, "data.statusId", ""));
    useEffect(() => {
        setBtns(
            <Stack className='mr-6' direction="row" spacing={2} justifyContent="flex-end">
                <Button
                    className="w-[150px] min-w-[150px]"
                    variant="outlined"
                    color="secondary"
                    startIcon={< HistoryIcon/>}
                    onClick={() => {
                        if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE/LOGS", "watch")) {
                            setOpenModalLog(true)
                        } else {
                            setAlert({
                                open: true,
                                title: "Permiso Denegado.",
                                subtitle: (<ul> • No tienes permiso para ver las modificaciones en facturación cliente.</ul>),
                                type: "error",
                                btn: __(`${module}.actions.close`),
                                func: closeAlert
                            })
                        }
                    }}
                    // disabled={get(put, "isLoading")}
                    >
                    Ver Cambios
                </Button>
                {isEdit && <LoadingButton className='w-[100px] min-w-[100px]' startIcon={<SaveIcon/>} variant="contained" color="secondary" type="submit" form="form-invoice" loading={get(put, "isLoading")}>{id ? __(`action.save`) : __(`action.new`)}</LoadingButton>}
                <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/transactions/invoices")} disabled={get(put, "isLoading")} >{__(`action.cancel`)}</Button>
            </Stack>
        )
    }, [get(put, "isLoading")])

    return (
        <div>
            {(get(current, "isLoading")) && !isMount
                ? (
                    <Skeleton />
                ) : (
                    <Formik enableReinitialize innerRef={formikRef} initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form id="form-invoice" onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='mt-4'>
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6} md={6} >
                                                <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
                                                    <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                                    <Typography component="h6" variant="h6">- {get(current, "data.billingTranckingId", "-")}</Typography>
                                                    <Chip label={get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "label")} sx={{ bgcolor: `${get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "color")}26`, color: get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "color") }} />    
                                                </Stack>
                                            </Grid>    
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                                {get(current, "data.odooSOname") ? (
                                                    <>
                                                        <Typography component="h6" variant="h6">SO Name: </Typography>
                                                        <RequestQuoteIcon color="success" />
                                                        <Typography component="h6" variant="h6">{get(current, "data.odooSOname", "-")}</Typography>
                                                    </>
                                                ) : <div />}
                                                </Stack> 
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6} md={6} >
                                                <AutoComplete
                                                    name={"idClient"}
                                                    formik={formik}
                                                    label={__(`form.idClient.label`)}
                                                    placeholder={__(`form.idClient.placeholder`)}
                                                    disabled={!isEmpty(get(current, "data.invoiceDetailList")) || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={clients}
                                                    loading={get(client, "isLoading")}
                                                    setIsMount={setIsMount}
                                                    {...(isEmpty(get(current, "data.invoiceDetailList")) ? {} : { inputProps: { helperText: __("labels.2") } })}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="comments"
                                                    label={__(`form.comments.label`)}
                                                    placeholder={__(`form.comments.placeholder`)}
                                                    disabled={get(current, "isLoading", false)}
                                                    multiline
                                                    rows={4}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <LogsModal
                __={__}
                open={openModalLog}
                close={() => setOpenModalLog(false)}
            />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </div>
    )
}

export default NewEdit
